module.exports = __webpack_public_path__ + "img/HC1028-169.0c7e0799.jpg";